const CartController = function (
  $scope,
  Cart,
  Voucher,
  $interval,
  Discount,
  $timeout
) {

  $scope.Voucher = Voucher;
  $scope.Discount = Discount;

  function focusVoucherLink() {
    $timeout(function () {
      requestAnimationFrame(function () {
        const els = document.querySelectorAll('.cart-voucher-link');
        const el = Array.prototype.find.call(els, function (e) { return e.offsetParent !== null; });
        if (el) { el.focus(); }
      });
    });
  }

  $scope.redeemVoucher = function () {
    Voucher.redeem($scope).then(focusVoucherLink).catch(angular.noop);
  };

  $scope.abortVoucher = function () {
    $scope.setShowVoucherForm(false);
    focusVoucherLink();
  };

  $scope.setShowVoucherForm = function (value) {
    if (value) {
      Voucher.redeemError = '';
      Voucher.code = '';
      Discount.showInfo = false;
    }
    $scope.showVoucherForm = value;
    if (value) {
      Voucher.focusVoucherInput();
    }
  };

  $scope.removeVoucher = function () {
    return $scope.$parent.removeVoucher();
  };

  $scope.scrollIndicatorBottom = false;
  $scope.scrollIndicatorTop = false;

  var cartItems = angular.element('.cart-cartItems');
  $scope.$cartItems = cartItems.find('.hide-mobile');

  $scope.setScrollIndicator = function () {
    if (!$scope.$cartItems.is(':visible')) {
      return;
    }
    // see file: _vars.scss:40
    // $cart-cartitems-height: 450px;
    var cartContainerHeight = 450;
    var cartContainerTopOffset = 55;

    var cartItemListHeight = $scope.$cartItems.height();
    var cartItemListPosition = $scope.$cartItems.position();

    $scope.scrollIndicatorBottom = (cartItemListHeight + cartItemListPosition.top - cartContainerHeight - cartContainerTopOffset > 10);
    $scope.scrollIndicatorTop = (cartItemListPosition.top < 55);
  };

  // because it should be set initial but only if the element is visible
  var onceTimeoutonceInterval = $interval(function () {
    if ($scope.$cartItems.is(':visible')) {
      $interval.cancel(onceTimeoutonceInterval);
      $scope.setScrollIndicator();
    }
  }, 100, 50);

  cartItems.on('scroll', function () {
    $scope.setScrollIndicator();
    $scope.$apply();
  });

  $scope.removeFromCart = function (item, key) {
    Cart.removeItemFormLocalstorage(item);
    return $scope.$parent.removeFromCart(item, key)
      .then(function () {
        if (!Cart.haveTickets()) {
          Cart.removeAllGiftwrapper();
        }
      })
      .then(function () {
        if (!Cart.haveBuyableItems()) {
          Cart.removeDiscount();
        }
      });
  };
};

export default CartController;
